<template>
    <section class="mt-16">
      <!-- barrinha de onde estamos -->
      <v-breadcrumbs
        :items="crumbs"
        divider="/"
        :class="$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        light
      />
  
      <!-- Titulo -->
      <h1 class="primary--text">
        <rp-icon icon="rp-money-blue-filled" class="mr-2" />
        {{$t('menu.expenses_management')}}
      </h1>
      <v-row>
        <v-col cols="12" md="auto">
          <rp-icon
            icon="rp-eye-blue-filled"
            class="mb-n2"
          /><v-icon class="ml-2" small color="secondary">mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.visualize')}}</span>
        </v-col>
        <v-col cols="12" md="auto" v-if="$root.session.hasPermission(['super', 'expenses.delete'])">
          <v-icon color="red" class="ml-4">
            mdi-delete
          </v-icon><v-icon class="ml-2" small color="secondary">mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.remove')}}</span>
        </v-col>
      </v-row>
  
      <!-- col Acoes -->
      <div style="position:relative">
        <v-container>
            <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
            >
            <template v-slot:activator>
                <v-btn color="primary" dark fab>
                <v-icon v-if="speedDial">mdi-close</v-icon>
                <v-icon v-else>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
    
            <v-btn fab dark small color="info" @click="searching = true">
                <v-icon>mdi-filter</v-icon>
            </v-btn>
    
            <!--
            <v-btn fab dark small color="success" @click="exporting = true">
                <v-icon>mdi-file-excel</v-icon>
            </v-btn>
            -->
    
            <v-btn
                fab dark small color="secondary"
                :to="'/' + $session.get('domain') + '/admin/expenses/create'"
                v-if="$root.session.hasPermission(['super', 'expenses.create'])"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            </v-speed-dial>
        </v-container>
    
        <!-- Tabela -->
        <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            :footer-props="tableFooter"
            :options.sync="options"
            :class="$root.$vuetify.theme.isDark ? 'secondary mt-16' : 'mt-16'"
            locale="pt-pt"
        >
            <template v-slot:item.valor_fatura="{ item }">
            {{ item.valor_fatura }} {{$store.state.coin}}
            </template>
    
            <template v-slot:item.user="{ item }">
            {{ item.user && item.user ? item.user : '-' }}
            </template>

            <template v-slot:item.status="{ item }">
            <v-chip :color="item.status == 'P' ? 'orange' : 'green'" dark>
                {{ statusLabel(item.status) }}
            </v-chip>
            </template>
    
            <template v-slot:item.actions="{ item }">
            <IconView class="mr-2" @click="viewExpense(item)" />
            <IconRemove
                v-if="$root.session.hasPermission(['super', 'expenses.delete']) && item.status == 'P'"
                class="mr-2"
                @on-submit="deleteExpense(item)"
            />
            </template>
        </v-data-table>
    </div>
  
      <!-- Drawer de Filtros -->
      <v-navigation-drawer 
        right 
        v-model="searching" 
        hide-overlay 
        width="400" 
        app
        temporary
        class="pt-6"
      >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
        <v-form @submit.prevent="searchExpenses">
          <v-text-field 
            class="ml-4 mr-4"
            v-model="filter.n_fatura" 
            prepend-inner-icon="mdi-file" 
            :label="$t('expenses.invoice_number')" 
            clearable 
          />
          <v-select
            class="ml-4 mr-4" 
            v-model="filter.status" 
            :items="statusOptions" 
            :label="$t('expenses.invoice_status')" 
            clearable 
          />
          <v-btn 
            color="primary" 
            type="submit" 
            class="mt-4">
            {{$t('globals.search')}}
          </v-btn>
        </v-form>
      </v-navigation-drawer>
  
      <!-- Dialogs e Loader -->
      <DialogSuccess :opened="started" @on-ok="started = false">
        {{$t('expenses.init_export')}}
      </DialogSuccess>
  
      <Loader v-if="exportingDocument" />
    </section>
  </template>
  
  <script>
  import IconRemove from '@/components/ui/IconRemove.vue';
  import IconView from '@/components/ui/IconView.vue';
  import DialogSuccess from '@/components/ui/DialogSuccess.vue';
  import Loader from '@/components/ui/Loader.vue';
  import Expenses from '../../api/Expenses.js';
  
  export default {
    components: { IconRemove, IconView, DialogSuccess, Loader },
    data: () => ({
      speedDial: false,
      searching: false,
      exporting: false,
      exportingDocument: false,
      started: false,
      items: [],
      total: 0,
      loading: false,
      options: {},
      filter: {
        n_fatura: null,
        status: null
      },
      statusOptions: ['P', 'A'],
    }),
    watch: {
      options: {
        handler() {
          this.getExpenses();
        },
        deep: true,
      }
    },
    mounted() {
      this.loading = true;
      this.getExpenses();
    },
    methods: {
      getExpenses() {
        /*
        Expenses.getAll()
          .then((response) => {
            this.items = response.data;
            this.total = response.data.length;  
            this.loading = false;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
            this.loading = false;
          });
          */

          this.loading = true;

          const request = {
            page: this.options.page || 1,
            limit: this.options.itemsPerPage || 10,
            sortBy: this.options.sortBy || ['created_at'],
            sortDesc: this.options.sortDesc || [true],
            ...this.filter
          };

          Expenses.search(request)
            .then((response) => {
              this.items = response.data.data;
              this.total = response.data.total;
              this.loading = false;
              console.log(response.data);
            })
            .catch((error) => {
              console.error(error);
              this.loading = false;
            });

      },
      searchExpenses() {
        /*
        this.loading = true;
        // Simular chamada API
        setTimeout(() => {
          this.loading = false;
          this.searching = false;
        }, 500);
        */
        this.options.page = 1;
        this.getExpenses();
        this.searching = false;
      },
      viewExpense(item) {
        this.$router.push('/' + this.$session.get('domain') + '/admin/expenses/' + item.id);
      },
      deleteExpense(item) {
        console.log('Delete', item);

        Expenses.delete(item.id)
          .then(() => {
            this.$store.dispatch('snackbar/showSnackbar', {
              text: this.$t('globals.delete_success'),
              color: 'success'
            });
            this.getExpenses();
          })
          .catch((error) => {
            console.error(error);
            this.$store.dispatch('snackbar/showSnackbar', {
              text: this.$t('globals.delete_error'),
              color: 'error'
            });
          });
      },
      statusLabel(status) {
        return status === 'P' ? this.$t('expenses.pending') : this.$t('expenses.approved');
      }
    },
    computed: {
      headers() {
        return [
          { 
            text: this.$t('expenses.invoice_date'), 
            value: 'data_fatura',
            sortable: true
          },
          { 
            text: this.$t('expenses.invoice_number'), 
            value: 'n_fatura' },
          { 
            text: this.$t('expenses.invoice_value'), 
            value: 'valor_fatura' 
          },
          { 
            text: this.$t('globals.user'), 
            value: 'user' 
          },
          { 
            text: this.$t('expenses.invoice_status'), 
            value: 'status',
            sortable: true
          },
          { 
            text: this.$t('globals.options'), 
            value: 'actions', 
            sortable: false 
          }
        ];
      },
      tableFooter() {
        return {
          'items-per-page-options': [5, 10, 20],
          'items-per-page-text': this.$t('globals.lines_datatable')
        };
      },
      crumbs() {
        return [
          { text: this.$t('menu.dashboard'), to: '/admin', exact: true },
          { text: this.$t('menu.expenses_management'), disabled: true }
        ];
      }
    }
  }
  </script>